import React, { useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/irislogo.png";
import styles from "./Navbar.module.scss";
import Hamburger from "../Hamburger";
import { LanguageContext } from "../../context/LanguageContext";

function Navbar() {
  const { language, setLanguage } = useContext(LanguageContext);
  const [active, setActive] = useState(false);

  const toggleLang = () => {
    if (language === "no") {
      setLanguage("en");
    } else {
      setLanguage("no");
    }
  };

  const handleMenuClick = () => {
    const menu = document.querySelector(`.${styles.nav_ul}`);
    menu.classList.toggle(`${styles.active}`);
    const isMenuActive = menu.classList.contains(`${styles.active}`);

    if (window.innerWidth < 768) {
      if (isMenuActive) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    }

    setActive(isMenuActive);
  };

  return (
    <header>
      <div className="container">
        <div className="wrap">
          <div className={styles.header_flex}>
            <div className={styles.logo}>
              <Link to="/">
                <img src={logo} alt="Logo" />
              </Link>
            </div>
            <nav>
              <ul className={styles.nav_ul}>
                <li>
                  <NavLink
                    to="/"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Hjem" : "Home"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/products"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Produkter" : "Products"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/contact"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Kontakt Oss" : "Contact Us"}
                  </NavLink>
                </li>
                <li>
                  <a href="https://instantiris.onlinebooq.net">
                    {language === "no" ? "Bestill Time" : "Book"}
                  </a>
                </li>
                {/* <li>
                  <NavLink
                    to="/franchise"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Franchise" : "Franchise"}
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/FAQ"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    FAQ
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/events"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Arrangementer" : "Events"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/giftcards"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Gavekort" : "Gift Cards"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/Gallery"
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? styles["active-link"] : ""
                    }
                    onClick={handleMenuClick}
                  >
                    {language === "no" ? "Galleri" : "Gallery"}
                  </NavLink>
                </li>
              </ul>
            </nav>
            <div className={styles.header_right}>
              <div className={styles.languageButton}>
                <button
                  onClick={toggleLang}
                  aria-label={
                    language === "en"
                      ? "Switch to Norwegian"
                      : "Switch to English"
                  }
                >
                  {language === "no" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 22 16"
                      aria-hidden="true"
                    >
                      <rect width="22" height="16" fill="#BA0C2F" />
                      <rect x="6" width="4" height="16" fill="#fff" />
                      <rect y="6" width="22" height="4" fill="#fff" />
                      <rect x="7" width="2" height="16" fill="#00205B" />
                      <rect y="7" width="22" height="2" fill="#00205B" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 60 30"
                      aria-hidden="true"
                    >
                      <rect width="60" height="30" fill="#012169" />
                      <path
                        d="M0,0 L60,30 M60,0 L0,30"
                        stroke="#fff"
                        strokeWidth="6"
                      />
                      <path
                        d="M0,0 L60,30 M60,0 L0,30"
                        stroke="#C8102E"
                        strokeWidth="2"
                      />
                      <path
                        d="M30,0 v30 M0,15 h60"
                        stroke="#fff"
                        strokeWidth="10"
                      />
                      <path
                        d="M30,0 v30 M0,15 h60"
                        stroke="#C8102E"
                        strokeWidth="6"
                      />
                    </svg>
                  )}
                </button>
              </div>
              <div className={styles.hamburgerDiv}>
                <button aria-label="Menu" onClick={handleMenuClick}>
                  <Hamburger active={active} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
